<template>
  <div>
    <v-row class="mb-2" cols="12" justify="space-between">
      <v-col sm="8">
        <v-icon small class="pr-1">fas fa-paperclip</v-icon>
        Attachments ({{ fileList.length }})
      </v-col>
      <v-col sm="4" class="text-sm-right">
        <v-btn @click="showDefaultDialog" icon dense small v-if="fileDropzone">
          <v-icon small class="font-weight-bold">fas fa-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-card v-if="!fileList.length">
      <v-card-text>
        <div>There are currently no attachments for this document.</div>
        <div><v-btn text @click="showDefaultDialog">Click to Upload File</v-btn></div>
      </v-card-text>
    </v-card>
    <attachments @insertFile="insertFile"></attachments>
    <div class="dropzone " v-show="showPreviews"><div id="previews">Uploading...</div></div>
    <div v-show="showModal" class="och-modal" id="uploadContainer">
      <div
        class="my-5"
        style="border: 5px dashed #ccc; border-radius: 25px; height: 500px; width: 600px; position: fixed; left: 50%; margin-left: -300px;"
      >
        <div style="text-align: center;">
          <div style="margin: 150px auto; color: #ccc;">
            <div><i class="fas fa-cloud-upload-alt fa-5x"></i></div>
            <div class="title mt-3">Drop files here</div>
            <div><v-btn @click="showModal = false" text color="grey lighten--2">Cancel</v-btn></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global Dropzone */
import Attachments from "@/components/attachments";

export default {
  name: "uploadsPreview",
  components: {
    Attachments,
  },
  computed: {
    fileList() {
      return this.$store.state.file.fileList;
    },
  },
  data() {
    return {
      fileDropzone: null,
      showModal: false,
      showPreviews: false,
    };
  },
  methods: {
    insertFile(file) {
      this.$emit("insertFile", file);
    },
    showDefaultDialog() {
      if (this.fileDropzone) {
        this.fileDropzone.hiddenFileInput.click();
      }
    },
  },
  mounted() {
    const that = this;
    Dropzone.autoDiscover = false;
    const releaseNoteId = this.ownerId;
    const type = this.ownerType;

    this.fileDropzone = new Dropzone("div#uploadContainer", {
      url: `/upload?type=${type}&id=${releaseNoteId}`,
      previewsContainer: "#previews",
      success(file) {
        setTimeout(() => {
          this.removeFile(file);
        }, 2000);
      },
      error(e) {
        console.error(e);
        const message = e.xhr?.status === 400 ? e.xhr.response : "Error uploading file";
        that.$notifyError({ message });
      },
    });
    const editForm = document.getElementById("editForm");
    editForm.addEventListener("dragenter", () => {
      this.showModal = true;
    });
    this.fileDropzone.on("dragleave", evt => {
      if (evt.target.id === "uploadContainer") {
        this.showModal = false;
      }
    });
    this.fileDropzone.on("drop", () => {
      this.showModal = false;
    });
    this.fileDropzone.on("addedfile", () => {
      this.showPreviews = true;
    });
    this.fileDropzone.on("queuecomplete", () => {
      try {
        this.$store.dispatch("file/list", {
          ownerId: this.ownerId,
          ownerType: this.ownerType,
        });
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: "Error fetching file list" });
      }
      setTimeout(() => {
        this.showPreviews = false;
      }, 2000);
    });
  },
  props: ["ownerId", "ownerType"],
};
</script>

<style>
.och-modal {
  background-color: rgba(0, 0, 0, 0.9);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
